webpackJsonp([1],{

/***/ "+HSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progress',
  props: [],
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    progress: 'team/progress'
  }))
});

/***/ }),

/***/ "1OD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"progressor",attrs:{"size":200,"width":25,"rotate":180,"value":_vm.progress,"color":"pink"}},[_vm._v("\n    "+_vm._s(_vm.progress.toFixed(2))+"%\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2q/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"menu"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.menu,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.price))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.reward))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6fBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1 chat",attrs:{"headers":_vm.headers,"items":_vm.log,"hide-actions":"","hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left message"},[_c('v-chip',{attrs:{"color":"indigo","text-color":"white"}},[_vm._v("\n        "+_vm._s(props.item.display_name)+"\n      ")]),_vm._v("\n      "+_vm._s(props.item.message)+"\n    ")],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ACZo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E20c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donations_vue__ = __webpack_require__("bLDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d556eb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donations_vue__ = __webpack_require__("af6+");
function injectStyle (ssrContext) {
  __webpack_require__("YyLC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d556eb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_donations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d556eb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_donations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H9rf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_team_vue__ = __webpack_require__("Q2ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ac669e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_team_vue__ = __webpack_require__("fDga");
function injectStyle (ssrContext) {
  __webpack_require__("UfD3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27ac669e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ac669e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HKa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_json__ = __webpack_require__("Kufx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_config_json__);




var app = __WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_1__firebase_config_json___default.a);

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__("sax8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_team__ = __webpack_require__("QciR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_chat__ = __webpack_require__("VAhz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_menu__ = __webpack_require__("egBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_settings__ = __webpack_require__("THyH");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    team: __WEBPACK_IMPORTED_MODULE_5__modules_team__["a" /* default */],
    chat: __WEBPACK_IMPORTED_MODULE_6__modules_chat__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_7__modules_menu__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_8__modules_settings__["a" /* default */]
  },
  strict: debug,
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "Kufx":
/***/ (function(module, exports) {

module.exports = {"apiKey":"AIzaSyCUD4EH9q-8V8bMr6kHPsUDQ6POpGTHk0M","authDomain":"cancer-sucks.firebaseapp.com","databaseURL":"https://cancer-sucks.firebaseio.com","projectId":"cancer-sucks","storageBucket":"cancer-sucks.appspot.com","messagingSenderId":"935142913902"}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c709952e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PGmk");
function injectStyle (ssrContext) {
  __webpack_require__("ACZo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c709952e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_plugin_load_script__ = __webpack_require__("wmV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_plugin_load_script__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router___default.a,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "PGmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":""}},[_vm._v(_vm._s(_vm.countdown))])],1)],1),_vm._v(" "),_c('main',[_c('v-content',[_c('v-container',{attrs:{"grid-list-lg":"","text-md-center":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('c-progress')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('c-team')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('twitch-player',{attrs:{"channel":_vm.channel}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('p',{staticClass:"headline mb-0"},[_vm._v("Twitch Stream")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('c-chat')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":"","xs12":""}},[_c('c-donations')],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","xs12":""}},[_c('c-menu')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q2ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'team',
  props: [],
  mounted: function mounted() {
    this.$store.dispatch('team/init');
  },
  data: function data() {
    return {
      size: 150,
      bar: 5,
      avatar: '15px'
    };
  },

  methods: {
    goTo: function goTo(url) {
      window.open(url);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    team: 'team/list'
  }), {
    avatarSize: function avatarSize() {
      return this.size - this.bar * 2.5 + 'px';
    }
  })
});

/***/ }),

/***/ "QXW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__ = __webpack_require__("wcVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e647bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__ = __webpack_require__("6fBM");
function injectStyle (ssrContext) {
  __webpack_require__("vVx5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e647bce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e647bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QciR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__("IcnI");






var ref = {};
var makeRef = function makeRef() {
  ref = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database().ref('/member');
  ref.once('value', function (snapshot) {
    __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].commit('team/load', snapshot.val());
  });
  ref.on('child_added', function (data) {
    __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].commit('team/add', { snapshot: data.val(), key: data.key });
  });
  ref.on('child_removed', function (data) {
    __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].commit('team/delete', data.key);
  });
  ref.on('child_changed', function (data) {
    __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].commit('team/update', { snapshot: data.val(), key: data.key });
  });
};

var makeTeamDetails = function makeTeamDetails(id) {
  var teamRef = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database().ref('/team/' + id);
  teamRef.on('value', function (snapshot) {
    __WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */].commit('team/details', snapshot.val());
  });
};

// initial state
var state = {
  list: {},
  details: {},
  array: [],
  progress: 0,
  donations: []
};

// getters
var getters = {
  list: function list(state) {
    return state.list;
  },
  array: function array(state) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.list);
  },
  details: function details(state) {
    return state.details;
  },
  progress: function progress(state) {
    if (state.details.totalRaisedAmount) {
      return state.details.totalRaisedAmount / state.details.fundraisingGoal * 100;
    }
    return 0;
  },
  donations: function donations(state) {
    if (state.list) {
      var compiled = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.list)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var member = _step.value;

          if (member.donations) {
            compiled = compiled.concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(member.donations));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return compiled;
    }
    return [];
  }
};

// actions
var actions = {
  init: function init() {
    makeRef();
  },
  initDetails: function initDetails(context, id) {
    makeTeamDetails(id);
  }
};

/* eslint-disable no-param-reassign */
// mutations
var mutations = {
  load: function load(state, snapshot) {
    state.list = snapshot;
  },
  add: function add(state, _ref) {
    var snapshot = _ref.snapshot,
        key = _ref.key;

    var temp = {};
    temp[key] = snapshot;
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list, temp);
  },
  setCurrent: function setCurrent(state, snapshot) {
    state.current = snapshot;
  },
  delete: function _delete(state, key) {
    delete state.list[key];
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list);
  },
  update: function update(state, _ref2) {
    var snapshot = _ref2.snapshot,
        key = _ref2.key;

    state.list[key] = snapshot;
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list);
  },
  details: function details(state, _details) {
    state.details = _details;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "THyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("IcnI");



var ref = {};
var makeRef = function makeRef() {
  ref = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].database().ref('/settings');
  ref.on('value', function (snapshot) {
    // console.log(snapshot);
    __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].commit('settings/load', snapshot.val());
  });
};
// initial state
// shape: [{ id, quantity }]
var state = {
  start: '2017-12-29',
  title: 'Loading...',
  blerb: 'Loading...',
  channel: 'LibertyBeta'
};

// getters
var getters = {
  start: function start(state) {
    return state.start;
  },
  title: function title(state) {
    return state.title;
  },
  blerb: function blerb(state) {
    return state.blerb;
  },
  channel: function channel(state) {
    return state.channel;
  }
};

// actions
var actions = {
  init: function init() {
    makeRef();
  }
};

/* eslint-disable no-param-reassign */
// mutations
var mutations = {
  load: function load(state, snapshot) {
    if (snapshot.team) {
      var id = snapshot.team;
      __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].dispatch('team/initDetails', id);
    }
    state.start = snapshot.start;
    state.title = snapshot.title;
    state.blerb = snapshot.blerb;
    state.channel = snapshot.channel;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "UfD3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {



/***/ }),

/***/ "VAhz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__("IcnI");





var ref = {};
var makeRef = function makeRef() {
  ref = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* default */].database().ref('/log').limitToLast(6).orderByChild('tmi_sent_ts');
  ref.once('value', function (snapshot) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('chat/load', snapshot.val());
  });
  ref.on('child_added', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('chat/add', data.val());
  });
  ref.on('child_removed', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('chat/delete', data.val());
  });
  ref.on('child_changed', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('chat/update', data.val());
  });
};

var sorter = function sorter(a, b) {
  if (a.tmi_sent_ts < b.tmi_sent_ts) return true;
  if (a.tmi_sent_ts > b.tmi_sent_ts) return false;
  return false;
};
// initial state
var state = {
  history: [{
    auth: 'system',
    message: 'No Mesasges from Twitch Loaded...'
  }]
};

// getters
var getters = {
  history: function history(state) {
    return state.history;
  },
  message: function message(state) {
    return state.history.map(function (e) {
      return e.message;
    });
  }
};

// actions
var actions = {
  init: function init() {
    makeRef();
  }
};

/* eslint-disable no-param-reassign */
// mutations
var mutations = {
  load: function load(stateSnapshot, snapshot) {
    state.history = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(snapshot).sort(sorter);
  },
  add: function add(stateSnapshot, snapshot) {
    if (stateSnapshot.history.some(function (x) {
      return x.id === snapshot.id && x.tmi_sent_ts === snapshot.tmi_sent_ts;
    })) {
      __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('chat/update', snapshot);
    } else {
      stateSnapshot.history.push(snapshot);
      state.history = stateSnapshot.history.sort(sorter);
    }
  },
  delete: function _delete(stateSnapshot, element) {
    var jsoned = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(element);
    state.history = stateSnapshot.history.filter(function (e) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e) !== jsoned;
    }).sort(sorter);
  },
  update: function update(stateSnapshot, element) {
    var index = stateSnapshot.history.findIndex(function (x) {
      return x.id === element.id && x.tmi_sent_ts === element.tmi_sent_ts;
    });
    if (index !== -1) stateSnapshot.history[index] = element;
    state.history = stateSnapshot.history.sort(sorter);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "X7kc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("+HSz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf441ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__ = __webpack_require__("1OD7");
function injectStyle (ssrContext) {
  __webpack_require__("urcA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cf441ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf441ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, exports) {

// import Vue from 'vue';
// import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld';

// Vue.use(Router);

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'Hello',
//       component: HelloWorld,
//     },
//   ],
// });

/***/ }),

/***/ "YyLC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "af6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-data-table',{staticClass:"elevation-1 chat",attrs:{"headers":_vm.headers,"items":_vm.donations,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left message"},[_vm._v(_vm._s(( new Date(props.item.createdOn)).toLocaleDateString()))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("$"+_vm._s(props.item.donationAmount.toFixed(2)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left message"},[_vm._v(_vm._s(props.item.message))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bLDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'donations',
  props: [],
  mounted: function mounted() {},
  data: function data() {
    return {
      headers: [{
        text: 'When',
        align: 'left',
        sortable: false,
        value: 'createdOn'
      }, {
        text: 'Amount',
        align: 'right',
        sortable: false,
        value: 'donationAmount'
      }, {
        text: 'Message',
        align: 'left',
        sortable: false,
        value: 'Message'
      }]
    };
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    donations: 'team/donations'
  }))
});

/***/ }),

/***/ "ctpP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'team',
  props: [],
  mounted: function mounted() {
    this.$store.dispatch('menu/init');
  },
  data: function data() {
    return {
      headers: [{
        text: 'Price',
        align: 'left',
        sortable: false,
        value: 'price'
      }, {
        text: 'Reward',
        align: 'left',
        sortable: false,
        value: 'reward'
      }]
    };
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    menu: 'menu/array'
  }))
});

/***/ }),

/***/ "egBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__("HKa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__("IcnI");





var ref = {};
var makeRef = function makeRef() {
  ref = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* default */].database().ref('/menu');
  ref.once('value', function (snapshot) {
    // console.log(snapshot);
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('menu/load', snapshot.val());
  });
  ref.on('child_added', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('menu/add', { snapshot: data.val(), key: data.key });
  });
  ref.on('child_removed', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('menu/delete', data.key);
  });
  ref.on('child_changed', function (data) {
    __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].commit('menu/update', { snapshot: data.val(), key: data.key });
  });
};
// initial state
// shape: [{ id, quantity }]
var state = {
  list: {},
  array: []
};

// getters
var getters = {
  list: function list(state) {
    return state.list;
  },
  array: function array(state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.list);
  }
};

// actions
var actions = {
  init: function init() {
    makeRef();
    // console.log(ref);
  }
};

/* eslint-disable no-param-reassign */
// mutations
var mutations = {
  load: function load(state, snapshot) {
    state.list = snapshot;
  },
  add: function add(state, _ref) {
    var snapshot = _ref.snapshot,
        key = _ref.key;

    var temp = {};
    temp[key] = snapshot;
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list, temp);
  },
  delete: function _delete(state, key) {
    delete state.list[key];
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list);
  },
  update: function update(state, _ref2) {
    var snapshot = _ref2.snapshot,
        key = _ref2.key;

    state.list[key] = snapshot;
    state.list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.list);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "fDga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.team),function(member){return _c('v-flex',{staticClass:"thing",attrs:{"md6":"","xs12":""}},[_c('v-progress-circular',{staticClass:"mouseable",attrs:{"size":_vm.size,"width":_vm.bar,"rotate":90,"value":(member.totalRaisedAmount /  member.fundraisingGoal) * 100,"color":"pink"},on:{"click":function($event){_vm.goTo(member.donateURL)}}},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":_vm.avatarSize}},[_c('img',{attrs:{"src":member.avatarImageURL,"alt":"avatar"}})])],1)],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {



/***/ }),

/***/ "nxsu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "urcA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vVx5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wcVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chat',
  props: [],
  mounted: function mounted() {
    this.$store.dispatch('chat/init');
  },
  data: function data() {
    return {
      headers: [{
        text: 'User',
        align: 'left',
        sortable: false,
        value: 'display_name'
      }, {
        text: 'message',
        align: 'right',
        sortable: false,
        value: 'message'
      }]
    };
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    log: 'chat/history',
    messages: 'chat/message'
  }))
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_clear_immediate__ = __webpack_require__("FUy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_clear_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_clear_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_twitch_player__ = __webpack_require__("bfGl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_twitch_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_twitch_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_progress__ = __webpack_require__("X7kc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_donations__ = __webpack_require__("E20c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_menu__ = __webpack_require__("zIkb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_team__ = __webpack_require__("H9rf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_chat__ = __webpack_require__("QXW3");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      now: '...',
      countdown: '00:00:00:00',
      inerval: null,
      data: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('settings/init');
    this.interval = setInterval(function () {
      _this.now = new Date().toISOString();
    }, 1000);
    this.data = setInterval(function () {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open('GET', 'https://us-central1-cancer-sucks.cloudfunctions.net/fetchlife');
      xmlHttp.send(null);
    }, 30 * 60 * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_clear_immediate___default()(this.data);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    title: 'settings/title',
    channel: 'settings/channel'
  })),
  watch: {
    now: function now() {
      // console.log(this.$store.state.settings.title);
      var start = new Date(Date.parse(this.$store.state.settings.start)).getTime();
      var now = new Date().getTime();

      var diff = Math.abs(start - now);

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      days = days >= 10 ? days : '0' + days;
      var hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      hours = hours >= 10 ? hours : '0' + hours;
      var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      minutes = minutes >= 10 ? minutes : '0' + minutes;
      var seconds = Math.floor(diff % (1000 * 60) / 1000);
      seconds = seconds >= 10 ? seconds : '0' + seconds;

      var dur = days + ' :  ' + hours + ' : ' + minutes + ' : ' + seconds;
      if (start < now) {
        this.countdown = dur;
      } else {
        this.countdown = '- ' + dur;
      }
    }
  },
  components: {
    'c-progress': __WEBPACK_IMPORTED_MODULE_4__components_progress__["a" /* default */],
    'c-team': __WEBPACK_IMPORTED_MODULE_7__components_team__["a" /* default */],
    'c-menu': __WEBPACK_IMPORTED_MODULE_6__components_menu__["a" /* default */],
    'c-donations': __WEBPACK_IMPORTED_MODULE_5__components_donations__["a" /* default */],
    'c-chat': __WEBPACK_IMPORTED_MODULE_8__components_chat__["a" /* default */],
    'twitch-player': __WEBPACK_IMPORTED_MODULE_3_vue_twitch_player___default.a
  }
});

/***/ }),

/***/ "zIkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__("ctpP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6723e8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__("2q/n");
function injectStyle (ssrContext) {
  __webpack_require__("nxsu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6723e8a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6723e8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4ef390ca5988bfafa41e.js